import { z } from "zod"
import { OrganizationTypeEnum } from "../../companies/dtos"
import { createFilterBySchema } from "../../shared/filter_dtos"
import { PaginationSchema } from "../../shared/pagination_dtos"
import { QuerySchema } from "../../shared/query_dtos"
import { createSortSchema } from "../../shared/sort_dtos"

export const BackofficeOrganizationsSortFields = ["id", "name", "slug", "createdAt"] as const
export type BackofficeOrganizationsSortFieldsEnum =
  (typeof BackofficeOrganizationsSortFields)[number]
export const BackofficeOrganizationsSortSchema = createSortSchema(
  BackofficeOrganizationsSortFields,
  "id",
  "asc",
)

export const BackofficeOrganizationsFilterBySchema = createFilterBySchema([
  {
    key: "type",
    value: z.array(z.enum(OrganizationTypeEnum)).optional(),
  },
])

export const GetBackofficeOrganizationsSchema = z.object({
  ...PaginationSchema.extend(QuerySchema.shape)
    .extend(BackofficeOrganizationsSortSchema.shape)
    .extend(BackofficeOrganizationsFilterBySchema.shape).shape,
})

export const GetBackofficeOrganizationParamsSchema = z.object({
  id: z.string().transform(BigInt),
})
